import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      showOnRepositionWarning: false,
      placementPopoverImageUrl: ""
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    activeUGCComponentName() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].activeUGCComponent;
    },
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    nextUGCComponent() {
      return this.$store.getters["ugc/getNextUGCComponent"];
    },
    nextUGCComponentDisplayName() {
      return (this as any).translations[`component${(this as any).nextUGCComponent}`];
    },
    isRepositionWarningFlowActive() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].storeMultipleUGCsizes;
    },
    getUgcFlowViews() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugcFlowViews;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    isSecondaryImage() {
      return this.$store.state.ugc.isUGCLoadingFromEntrypoint === 2;
    },
    enableNewUgcModal() {
      return this.$store.state.utils.configuration.enableNewUgcModal;
    },
    checkerboarderActive() {
      return this.$store.state.utils.queryParams.feature === 'checkerboarder';
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    ugcFeature() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugcFeature;
    }
  },
  watch: {
  },
  methods: {
    trackData(ugcStep = 'uploadAnotherClick', eventLabel = 'uploadAnotherClick', eventLabelEcom = 'uploadAnotherPhotoEcom') {
      if (!this.useEcomDataLayerFormat) {
        (window as any).dataLayer.push({
          ugcStep,
          timeStamp: new Date().toISOString(),
          event: "ugcStep",
          eventCategory: 'customs',
          eventAction: this.$store.state.transferDesign.isCustomizerTransferredModel ? 'Customizer - Change Style - UGC Flow' : 'UGC',
          eventLabel
        });
      } else {
        (this as any).$ugcDataLayer.logAnalyticsEvent({
          action: this.$store.state.transferDesign.isCustomizerTransferredModel ? 'transferDesign' : 'ugc',
          type: eventLabelEcom
        });
      }
    },
    /**
     * @function getPlacementTooltipImage
     * Set placementPopoverImageUrl with the next component from almost done.
     */
    setPlacementPopoverImageUrl() {
      const componentName = this.nextUGCComponent;
      const image = this.pdm.components[componentName].ugc.placements[0].reference_image_url;
      this.placementPopoverImageUrl = this.$store.state.endPoints.customizer.s3ModelsBucket + image;
    },
    continueFlow() {
      this.$store.commit("ugc/stateManager/SET_SKIP_ALMOST_DONE", false);
      this.$store.commit("ugc/stateManager/NEXT_CURRENT_UGC_VIEW");
      this.$store.commit("ugc/tempData/SET_BACKGROUND");
      this.$store.commit("ugc/tempData/DISABLE_BG", false);
    },
    clearStoredData() {
      this.$store.commit("ugc/tempData/CHANGE_UGC_ACTIVE_COMPONENT");
      this.$store.commit("ugc/tempData/RESET_PLACEMENT_VIEW_ORDER");
      this.$store.commit("ugc/stateManager/CLEAR");
      // removes the saved buffer because it has higher priority than the uploaded image URL
      this.$store.commit("ugc/placements/CLEAR_COMPONENT_BUFFER", this.nextUGCComponent);
      // removes the cropper state in case the user has used the cropper tool and returned to upload a new image
      this.$store.commit("ugc/tempData/SAVE_CROPPER_STATE", { componentName: this.nextUGCComponent });
      this.$store.commit("ugc/placements/CLEAR_PLACEMENTS");
      this.$store.commit(
        "ugc/tempData/SAVE_STATE_MANAGERS",
        this.$store.state.ugc.stateManager
      );
    },
    onSelectAnotherClick() {
      this.$store.commit("ugc/stateManager/NEXT_CURRENT_UGC_VIEW");
      this.$store.commit("imageGallery/SET_SECOND_COMPONENT_FLOW", true);
      this.$store.commit("ugc/tempData/SET_SELECT_ANOTHER", true);
      this.$eventBus.$emit('image-library-close-ugc', {selectAnother: true});
      this.$eventBus.$emit('select-another-image-assets');
    },
    onUploadAnotherClick() {
      this.$store.commit("ugc/tempData/SET_UPLOAD_ANOTHER", true);
      this.$eventBus.$off("upload-another-success", this.uploadAnotherImage);
      this.$eventBus.$once("upload-another-success", this.uploadAnotherImage);
      const labelElement = document.getElementsByClassName("ugc-uploader-label") as HTMLCollectionOf<HTMLElement>;
      labelElement[0].click();
      this.trackData();
    },
    uploadAnotherImage() {
      const { tempData } = this.$store.state.ugc;
      const storeMultipleUGCsizes = tempData.features[tempData.activeUGCIndex].storeMultipleUGCsizes;
      this.continueFlow();
      this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {});

      this.clearStoredData();
      this.$store.commit(
        "ugc/tempData/SET_STORE_MULTIPLE_UGC_SIZES",
        storeMultipleUGCsizes
      );
      this.$store.commit("ugc/tempData/SET_UPLOAD_ANOTHER", true);

      this.$store
        .dispatch("ugc/SAVE_ASSETS_3D")
        .then(() => {
          // Fix for VFDP-106459 We will need to test it on master as well.
          //document.getElementsByClassName("ugc-uploader-label")[0].click();
          this.$eventBus.$on("image-finished-loading", this.changeViewBack);
          this.$eventBus.$emit("upload-another-assets-3d");
          this.$eventBus.$on("image-set", () => {
            this.$store.commit("ugc/tempData/SET_UPLOAD_ANOTHER", false);
          });
          this.$store.commit("ugc/stateManager/SET_LOADING", false);
          this.trackData('uploadAnotherFinish', 'uploadAnotherFinish', (this as any).$ugcDataLayer.types.uploadAnotherPhotoEcom);

          if (tempData.features[tempData.activeUGCIndex].ugcFeature) {
            this.$store.commit("ugc/tempData/SET_UGC_FEATURE", null);
          }
        })
        .catch(err => {
          console.error("Error saving assets 3d", err);
        });
    },
    continueSameImage() {
      const isReposition = !!this.isRepositionWarningFlowActive || this.recipe_v2.components[this.nextUGCComponent].ugc;
      const { tempData } = this.$store.state.ugc;
      const storeMultipleUGCsizes = tempData.features[tempData.activeUGCIndex].storeMultipleUGCsizes;
      this.continueFlow();
      this.loadSameImage();
      this.clearStoredData();
      this.$store.commit(
        "ugc/tempData/SET_STORE_MULTIPLE_UGC_SIZES",
        storeMultipleUGCsizes
      );
      this.$store.dispatch("ugc/SAVE_ASSETS_3D").then(() => {
        this.changeViewBack();
        const defaultUGCSwatchId = this.$store.state.recipe.initRecipe.components[this.activeUGCComponentName].swatch_id;
        const recipeComponent = this.recipe_v2.components[this.activeUGCComponentName];
        const isUgcSwatch = (this as any).$ugc.isUGCFromSwatch(recipeComponent.swatch_id) || (this as any).$ugc.isUGCCreatedByFeature(recipeComponent, { includePatternMaker: true, includeCustomCheckerboard: true, });
        const ugc = isReposition && !isUgcSwatch ? this.recipe_v2.components[this.activeUGCComponentName].ugc : null;
        if (this.activeUGCIndex === 1) {
          this.$eventBus.$emit('image-library-same-image');
        }
        if (ugc) {
          if (ugc.background_color) {
            this.$store.commit("ugc/tempData/DISABLE_BG");
            this.$store.commit(
              "ugc/tempData/SET_BACKGROUND",
              ugc.background_color
            );
          }
          if (ugc.filter_applied) {
            this.$store.commit("ugc/stateManager/APPLY_TILE_OR_POPART", true);
          }
          this.$store.commit("ugc/tempData/ADD_UGC_COMPONENT", {
            componentName: this.activeUGCComponentName,
            defaultUGCSwatchId,
            ugc,
            replaceUgc: true,
            uploadedAnother: this.$store.getters['ugc/tempData/uploadedAnotherImage'],
          });
        }
        this.$store.commit("ugc/stateManager/SET_LOADING", false);
        if (this.ugcFeature && tempData.features[tempData.activeUGCIndex].replaceComponentFeature.length > 0) {
          this.$store.commit("ugc/tempData/SET_UGC_FEATURE", null);
        }
      });
      if (this.$store.getters["utils/isGCC"]) {
        this.$eventBus.$emit("image-set");
      }
      this.trackData('continueSameImage', 'continueSameImage', (this as any).$ugcDataLayer.types.continueSamePhoto);
      if (this.checkerboarderActive) {
        (this as any).$ugcDataLayer.logAnalyticsEvent({
          action: 'checkerboarder',
          type: (this as any).$ugcDataLayer.types.continueSamePhoto
        });
      }
    },
    changeViewBack() {
      this.$store.commit("ugc/CHANGE_UGC_VIEW", false);
      this.$eventBus.$off("image-finished-loading", this.changeViewBack);
    },
    openConfirmDesign() {
      let eventAction = this.checkerboarderActive ? 'checkerboarder' : 'ugc';
      if (this.activeUGCIndex === 1) {
        const views = this.$store.state.imageGallery.navigation.views;
        this.$store.commit("imageGallery/SET_ACTIVE_VIEW", this.getUgcFlowViews[this.getUgcFlowViews.length - 1]);
        eventAction = 'imageLibrary';
      }
      // TODO: get images from img srv before changing to confirm design
      this.$store.commit(
        "ugc/stateManager/SET_CURRENT_UGC_VIEW",
        this.getUgcFlowViews.length - 1
      );
      this.$store.commit("ugc/stateManager/SET_SKIP_ALMOST_DONE", true);
      this.$store.commit("ugc/CHANGE_UGC_VIEW", true);
      (this as any).$ugcDataLayer.logAnalyticsEvent({
        action: eventAction,
        type: (this as any).$ugcDataLayer.types.finishAlmostDone
      });
    },
    showRepositionWarningEl() {
      const ugcComponents = this.$store.getters["ugc/getUGCEnabledComponents"];
      const ugcCustomizedComponents = this.$store.getters[
        "ugc/getUGCCustomizedComponents"
      ].filter((e: any) => {
        return (
          !(this as any).$ugc.isUGCFromSwatch(
            this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].recipe.components[e].swatch_id
          ) &&
          !(this as any).$ugc.isUGCCreatedByFeature(
            this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].recipe.components[e],
            {
              includePatternMaker: true,
              includeCustomCheckerboard: true,
            }
          )
        );
      });
      if (
        this.isRepositionWarningFlowActive &&
        ugcCustomizedComponents.length === ugcComponents.length
      ) {
        this.showOnRepositionWarning = true;
      }
    },
    /**
     * @function loadSameImage
     * Load the same image used in the first component.
     * Get the image from tempRecipe and save it in ugc_image inside tempData vuex.
     */
    loadSameImage() {
      if (!this.isSecondaryImage) {
        const component = this.isRepositionWarningFlowActive ? this.nextUGCComponent : this.activeUGCComponentName;
        const { tempData } = this.$store.state.ugc;
        const { recipe } = tempData.features[tempData.activeUGCIndex];
        const { image_id, image_url } = (this.ugcFeature && tempData.activeUGCIndex !== 1)
          ? recipe.components[component].ugc.placements[0]
          : (recipe.components[component].ugc?.original_image || recipe.components[this.activeUGCComponentName].ugc?.original_image)
        const fileFormat = image_url.split(".").pop();
        this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {
          imagePath: image_url,
          temp_image_id: image_id,
          imageFormat: fileFormat
        });
      }
      if (!this.isRepositionWarningFlowActive) this.$store.commit("ugc/tempData/SET_STORE_MULTIPLE_UGC_SIZES", false);
    },
  },
  mounted() {
    if (!this.useEcomDataLayerFormat) {
      (this as any).$ugcDataLayer.logAnalyticsEvent({
        action: this.checkerboarderActive ? 'checkerboarder' : 'ugc',
        type: (this as any).$ugcDataLayer.types.steps
      });
    }
    this.$eventBus.$emit("hide-next-button", true);
    this.$store.commit("ugc/stateManager/SET_LOADING", false);
    this.$store.commit("ugc/stateManager/SET_SKIP_ALMOST_DONE", false);
    this.showRepositionWarningEl();
    this.setPlacementPopoverImageUrl();
    this.$emit('showBackButton', true);
  }
});
